import {useQuery} from 'react-query';
import {apiService} from '~services/ApiService';
import {useUserStore} from '~providers/userStore/zustand';

export interface PyxiSelectStatusResponse {
  filled: string[];
  not_filled: string[];
}

export function useGetPyxiSelectQuizStatus(enabled: boolean = true, form_type: string) {
  const userId = useUserStore.getState().user?.uid;

  return useQuery<PyxiSelectStatusResponse>(
    ['pyxiSelectQuizStatus', userId, form_type],
    async () => {
      // For 'user' form type, we want all fields (user + general + reset_table)
      // So we don't send form_type parameter to get all fields
      const params = form_type === 'user' ? {} : { form_type: form_type };
      
      return await apiService.getWithParams<PyxiSelectStatusResponse>('pyxi-select/quiz/status', params);
    },
    {
      enabled: !!userId && enabled
    },
  );
}

export default useGetPyxiSelectQuizStatus;
